// Задачи рекламируемой страницы
export type PageGoal =
  | 'buy_course'
  | 'webinar_registration'
  | 'marathon_registration'
  | 'consultation_request'
  | 'buy_mini_course'
  | 'get_checklist'
  | 'get_lessons'
  | 'subscribe_tg_channel'
  | 'subscribe_bot';

export const PAGE_GOALS: { value: PageGoal; label: string }[] = [
  { value: 'buy_course', label: 'Купить курс' },
  { value: 'webinar_registration', label: 'Регистрация на вебинар' },
  { value: 'marathon_registration', label: 'Регистрация на марафон' },
  { value: 'consultation_request', label: 'Заявка на консультацию' },
  { value: 'buy_mini_course', label: 'Купить миникурс, трипваер' },
  { value: 'get_checklist', label: 'Получить доступ к чек листу' },
  { value: 'get_lessons', label: 'Получить доступ к серии уроков' },
  { value: 'subscribe_tg_channel', label: 'Подписаться в TG канал' },
  { value: 'subscribe_bot', label: 'Подписаться в бота' },
];

// Платный продукт
export interface PaidProduct {
  name: string;
  keyIdea: string;
  averageCheck: number | null;
  salesPageUrl: string;
}

// Информация о компании
export interface CompanyInfo {
  companyName: string;
  companyActivity: string;
  authorName: string;
  authorDescription: string;
}

// Настройки проекта
export interface ProjectSettings {
  excludeWords: string[];
  keywords: string[];
}

// Рекламный кабинет
export interface AdAccount {
  id: string;
  name: string;
  type: 'yandex_direct' | 'vk';
  isConnected: boolean;
}

// Смысловая единица
export interface SemanticUnit {
  id: string;
  title: string;
  description: string;
  weight: number;
}

// Тема
export interface Theme {
  id: string;
  name: string;
  relevance: number;
  semanticUnits: SemanticUnit[];
}

// Сфера жизни
export interface LifeSphere {
  id: string;
  name: string;
  code: string;
  themes: Theme[];
}

// Сгенерированное объявление
export interface GeneratedAd {
  id: string;
  semanticUnitId: string;
  platform: 'yandex_direct' | 'vk';
  headline: string;
  subheadline: string;
  text: string;
  imageUrl: string;
  imageText: string;
  quickLinks: { title: string; url: string }[];
  clarifications: string[];
  status: 'draft' | 'pending' | 'sent' | 'active' | 'rejected' | 'error';
  errorMessage?: string;
}

// Рекламный проект
export interface AdProject {
  id: string;
  // Основное
  name: string;
  landingUrl: string;
  pageGoal: PageGoal;
  // Платный продукт
  paidProduct: PaidProduct;
  // О компании
  companyInfo: CompanyInfo;
  // Рекламные кабинеты
  adAccountIds: string[];
  // Настройки
  settings: ProjectSettings;
  // Заметки
  notes: string;
  // Режим работы
  mode: 'manual' | 'auto';
  // Анализ
  lifeSpheres: LifeSphere[];
  // Реклама
  generatedAds: GeneratedAd[];
  // Статус
  status: 'draft' | 'analyzing' | 'ready' | 'active' | 'paused';
  createdAt: string;
  updatedAt: string;
}

// Форма создания проекта
export interface ProjectFormValues {
  // Основное
  name: string;
  landingUrl: string;
  pageGoal: PageGoal;
  // Платный продукт
  productName: string;
  productKeyIdea: string;
  productAverageCheck: number | null;
  productSalesPageUrl: string;
  // О компании
  companyName: string;
  companyActivity: string;
  authorName: string;
  authorDescription: string;
  // Рекламные кабинеты
  adAccountIds: string[];
  // Настройки
  excludeWords: string;
  keywords: string;
  // Заметки
  notes: string;
  // Режим
  mode: 'manual' | 'auto';
}
